/**
 * Copies one or more document-level (root) field values onto every element of
 * a sub-array, unconditionally overwriting whatever each element currently
 * holds under that name.
 *
 * Unlike `sub.basic`'s `rootFieldsToOperate` (which borrows a root value as an
 * operand for an arithmetic result), this writes the root value itself onto
 * each element — for values that should simply track the header rather than
 * be computed from it (e.g. a line's currency following the document's).
 *
 * Config:
 * {
 *     logicType: 'calcFields',
 *     operationType: 'sub.setFromRoot',
 *     subEntity: 'lines',
 *     fields: ['baseCurrency', 'transactionCurrency']
 * }
 */
const subSetFromRoot = (data, operation) => {
    const { subEntity, fields } = operation

    if (!data || !Array.isArray(data[subEntity]) || !Array.isArray(fields)) {
        return data
    }

    const rootValues = Object.fromEntries(fields.map(field => [field, data[field]]))

    return {
        ...data,
        [subEntity]: data[subEntity].map(elem => ({ ...elem, ...rootValues }))
    }
}

export default subSetFromRoot
